import { get } from 'lodash'
import { SUBCATEGORIES } from 'constants/layout/setup-activity'

export default function(data, showMajor, mustBeMajor, isSimplifiedBronze) {
  const activity = {}

  if (data) {
    if (get(data, 'activityCategory.userDefined')) {
      activity.helpers = {
        category: get(data, 'activityCategory.parent.id'),
        subcategory: SUBCATEGORIES.others.value,
        others: get(data, 'activityCategory.translatedName')
      }
    } else {
      activity.helpers = {
        category: get(data, 'activityCategory.parent.id'),
        subcategory: get(data, 'activityCategory.id')
      }
    }
    activity.isMajor = get(data, 'isMajor')
    activity.aim = get(data, 'aim')
    activity.assessorEmail = get(data, 'assessorEmail')
    activity.assessorTitle = get(data, 'assessorTitle')
    activity.assessorName = get(data, 'assessorName')
    activity.assessorPhone = get(data, 'assessorPhone')
  }

  if (mustBeMajor && !isSimplifiedBronze) {
    activity.isMajor = true
  }

  if (!showMajor) {
    activity.isMajor = undefined
  }

  return activity
}
